import { branch, renderNothing } from 'recompose'
import Select from 'shared/components/Select'
import moment from 'moment'

import LiveOccupancyCharts from './LiveOccupancyCharts'
import AvailabilityLegendItem from './AvailabilityLegendItem'
import { OCCUPANCY_STATUSES } from '../constants'

import '../styles/avaliability.scss'

class Avaliability extends Component {
    constructor() {
        super()
        this.state = {
            selectedDayIndex: 0,
        }
        this.onSelectChange = this.onSelectChange.bind(this)
    }

    onSelectChange({ value }) {
        if (value)
            this.setState({
                selectedDayIndex: moment.weekdays().findIndex(day => day === value),
            })
    }

    renderLegendStatuses() {
        return Object.entries(OCCUPANCY_STATUSES).map(([key, { label }]) => (
            <AvailabilityLegendItem key={`${key}`} color={key} text={label} />
        ))
    }

    render() {
        const { data } = this.props
        const { selectedDayIndex } = this.state
        const weekDaysOptions = moment.weekdays().map(day => ({
            label: day.charAt(0).toUpperCase() + day.slice(1),
            value: day,
        }))
        return (
            <section className="avaliability-section">
                <div className="avaliability-board">
                    <div className="avaliability-header">
                        <div className="avaliability-title">
                            <T>car.park.availability.title</T>
                        </div>
                        <div className="avaliability-legend">{this.renderLegendStatuses()}</div>
                    </div>
                    <div className="row">
                        <div className="col-sm-4">
                            <Select
                                options={weekDaysOptions}
                                defaultValue={weekDaysOptions[0]}
                                onChange={this.onSelectChange}
                            />
                        </div>
                    </div>
                    <LiveOccupancyCharts dayUsageStats={data[selectedDayIndex].usage} />
                </div>
            </section>
        )
    }
}

export default compose(branch(props => !props.data, renderNothing))(Avaliability)
